import React from 'react';
import { useTranslation } from 'react-i18next';
import { Facebook, Instagram, Linkedin, Mail, Phone, Twitter } from 'lucide-react';

const Footer = ({ onNavigateToProjects, onNavigateToSection }) => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-950 px-4 py-12 text-white">
      <div className="container mx-auto">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <h3 className="brand-wordmark mb-4 text-2xl text-white">
              <span className="font-bold">CROPSBREED</span>{' '}
              <span className="font-normal">SA</span>
            </h3>
            <p className="text-sm text-gray-400">{t('footer.tagline')}</p>
          </div>
          <div>
            <h4 className="mb-4 font-bold">{t('footer.navigation')}</h4>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => onNavigateToSection('inicio')} className="text-gray-400 transition-colors hover:text-white">{t('footer.home')}</button></li>
              <li><button onClick={onNavigateToProjects} className="text-gray-400 transition-colors hover:text-white">{t('footer.projects')}</button></li>
              <li><button onClick={() => onNavigateToSection('que-hacemos')} className="text-gray-400 transition-colors hover:text-white">{t('navigation.services')}</button></li>
              <li><button onClick={() => onNavigateToSection('contacto')} className="text-gray-400 transition-colors hover:text-white">{t('navigation.contact')}</button></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 font-bold">{t('footer.contactQuick')}</h4>
            <p className="flex items-center gap-2 text-sm text-gray-400">
              <Phone className="h-4 w-4" /> +54 11 1234-5678
            </p>
            <p className="mt-2 flex items-center gap-2 text-sm text-gray-400">
              <Mail className="h-4 w-4" /> info@Breeding Digital.com.ar
            </p>
          </div>
          <div>
            <h4 className="mb-4 font-bold">{t('footer.social')}</h4>
            <div className="flex gap-4">
              <a href="#" aria-label={t('footer.facebook')} className="rounded-full bg-gray-800 p-2 text-gray-400 transition-colors hover:bg-gray-700 hover:text-blue-400">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" aria-label={t('footer.twitter')} className="rounded-full bg-gray-800 p-2 text-gray-400 transition-colors hover:bg-gray-700 hover:text-blue-400">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" aria-label={t('footer.instagram')} className="rounded-full bg-gray-800 p-2 text-gray-400 transition-colors hover:bg-gray-700 hover:text-pink-400">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" aria-label={t('footer.linkedin')} className="rounded-full bg-gray-800 p-2 text-gray-400 transition-colors hover:bg-gray-700 hover:text-blue-500">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-800 pt-6 text-center text-sm text-gray-400">
          © {new Date().getFullYear()} Cropsbreed SA {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
